import styled from 'styled-components';

export const transitionalEventStyle = {
  containerView: {
    // flex: 1,
    overflow: 'hidden',
  },
};

export const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1; /* Ensures loader is on top of the chart */
`;
